import { useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export default function ReviewSubmitted({
  name,
  success,
}: {
  name: string | undefined;
  success: boolean;
}) {
  const router = useRouter();
  const { t } = useTranslation("profile");
  const { t: tCommon } = useTranslation("common");
  return (
    <div className="flex flex-col gap-6 w-full max-w-[1140px]">
      <div className="w-full bg-white rounded-2xl shadow-md p-8 flex flex-col">
        <div className="mb-4">
          <button
            className="text-sm text-amber-700"
            onClick={() => router.history.back()}
          >
            {tCommon("backArrow")}
          </button>
        </div>
        <h2 className="heading-2 b-2">
          {success ? t("reviewSubmitted.thankYou") : t("reviewSubmitted.failed")}
        </h2>
        <div className="flex items-center gap-4 mt-4">
          <div
            className={`w-12 h-12 rounded-full border flex items-center justify-center ${success ? "border-amber-400 text-amber-400" : "border-red-400 text-red-400"}`}
          >
            {success ? "✓" : "✗"}
          </div>
          <div>
            <div className="text-base">
              {success
                ? name
                  ? t("reviewSubmitted.successWithName", { name })
                  : t("reviewSubmitted.successFallback")
                : name
                  ? t("reviewSubmitted.alreadyReviewedWithName", { name })
                  : t("reviewSubmitted.alreadyReviewedFallback")}
            </div>
            {success && (
              <div className="text-sm text-muted-foreground mt-3">
                {t("reviewSubmitted.postedNote")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
